<template>
    <div class="step" :class="props.step.code">
        <component :is="props.step.component" v-bind="props.step.props()" />
        <div v-if="showLoader" class="step-loader"></div>
    </div>
</template>

<script setup lang="ts">
import { type PropType } from 'vue';
import { storeToRefs } from 'pinia';
import type { Step } from '@/widgets/Wizard/models/step';
import { useStepsStore } from '@/widgets/Wizard/stores/steps';

const props = defineProps({
    step: {
        type: Object as PropType<Step>,
        required: true,
    },
});

const stepsStore = useStepsStore();
const { showLoader } = storeToRefs(stepsStore);
</script>
